module.exports = __webpack_public_path__ + "static/img/03.999c98bb.png";